module.exports = "<div class=action-title> <div class=\"pull-right action-desc\"> </div> <h3>{{ $ctrl.contents.title }}</h3> </div> <ng-transclude></ng-transclude> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/action-list.html
// module id = 1701
// module chunks = 86